import React, { Fragment, useState } from 'react';
import { Helmet } from 'react-helmet';
import { useHistory } from "react-router-dom";



const Otazka = () => {

    

    let history = useHistory();

    const  languageSlovak= () => {
        const element = document.querySelector('.slovak');
        element.classList.add('animate__animated', 'animate__bounceOut');
        setTimeout(() => { history.push("/home"); }, 600);
	};
    
    const  languageEnglish= () => {
        const element = document.querySelector('.british');
        element.classList.add('animate__animated', 'animate__bounceOut');
        setTimeout(() => { history.push("/home"); }, 600);
	};

    return (
        <Fragment>
        <Helmet><title>Languages</title></Helmet>
        <div id="home-lang">
            
            <section className='lang-home'>
               
                <div className='logo-container-lang'>
                  <img className='logo-lang' src={require('../img/darklogo.png')} alt="alt"/>
                </div>
                <div className='h1-container'>
                    <p className='h1-lang'>eduraw</p>
                </div>

                <div class="grid-container">
                    
                        <div class="grid-child slovak " onClick={() => languageSlovak()}>
                                <img className='flags ' src={require('../img/slovakia.png')} alt="alt"/>
                        </div>
                    
                        <div class="grid-child british" onClick={() => languageEnglish()}>
                                <img className='flags' src={require('../img/britain.png')} alt="alt"/>
                        </div>
  
                </div>

                <div class="grid-container">

                    <div class="grid-child-logo ">
                    <img className='logo-project' src={require('../img/rm.png')} alt="alt"/>
                    </div>

                    <div class="grid-child-logo ">
                    <img className='logo-project' src={require('../img/fberg.png')} alt="alt"/>
                    </div>
  
                </div>

                

                
            </section> 

            
        </div>  
      

    </Fragment>

   
    );
};


export default Otazka;




